import { Route } from '@angular/router';
import { CustomersComponent } from './customers.component';
import { CustomersDetailsComponent } from './customers-details/customers-details.component';

export const CUSTOMERS_ROUTES: Route[] = [
  {
    path: '',
    data: { name: 'Klanten' },
    children: [
      { path: ':id', component: CustomersDetailsComponent, data: { name: 'Details' } },
      { path: '', component: CustomersComponent },
    ],
  },
];
